import { FacebookCampaign } from './facebook';
import type { TEmailListFacebookCampaign } from './types';

export class EmailListFacebookCampaign extends FacebookCampaign<TEmailListFacebookCampaign> {}
